import script from "./RegistrationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationHeader.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationHeader.vue?vue&type=style&index=0&id=68c8f87e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c8f87e"]])

export default __exports__